import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";
import { useSelector } from "react-redux";

const CustomerFilters = ({ customerStats }) => {
  const { t } = useTranslation();

  const { statistics } = useSelector((state) => state.general);

  return (
    <div className="flex gap-6">
      {/* Top Info Cards - تأخذ ثلث المساحة */}
      <div className="flex flex-col gap-4 w-1/3">
        {/* Total Customers */}
        <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-5">
          <div className="flex justify-between items-start">
            <h4 className="text-base font-semibold text-foreground">
              {t("totalCustomers")}
            </h4>
            <button className="text-muted-foreground text-xl hover:text-foreground">
              ⋮
            </button>
          </div>
          <div className="mt-3 flex items-center space-x-2">
            <span className="text-3xl font-bold text-foreground">
              {statistics.all_clients_count}
            </span>
          </div>
        </div>

        {/* pending Customers */}
        <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-5">
          <div className="flex justify-between items-start">
            <h4 className="text-base font-semibold text-foreground">
              {t("new_clients_count")}
            </h4>
            <button className="text-muted-foreground text-xl hover:text-foreground">
              ⋮
            </button>
          </div>
          <div className="mt-3 flex items-center space-x-2">
            <span className="text-3xl font-bold text-foreground">
            {statistics?.new_clients_count}
            </span>
          </div>
        </div>

        {/* Visitor */}
        <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-5">
          <div className="flex justify-between items-start">
            <h4 className="text-base font-semibold text-foreground">
              {t("inactive")}
            </h4>
            <button className="text-muted-foreground text-xl hover:text-foreground">
              ⋮
            </button>
          </div>
          <div className="mt-3 flex items-center space-x-2">
            <span className="text-3xl font-bold text-foreground">
              0
            </span>
          </div>
        </div>
      </div>

      {/* Customer Overview - تأخذ باقي المساحة */}
      <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-5 w-2/3">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-foreground">
            {t("customerOverview")}
          </h3>
          <div className="flex space-x-2">
            <button className="text-xs px-3 py-1 bg-green-100 text-green-700 rounded-full border border-green-300">
              {t("this_week")}
            </button>
            <button className="text-xs px-3 py-1 rounded-full border border-gray-300 hover:bg-gray-100">
              {t("last_week")}
            </button>
            <button className="text-muted-foreground text-xl hover:text-foreground">
              ⋮
            </button>
          </div>
        </div>

       {/* <div className="grid grid-cols-4 gap-6 text-center border-b border-border pb-4 mb-4">
          <div>
            <div className="text-xl font-semibold text-foreground">25k</div>
            <div className="text-xs text-muted-foreground">
              {t("activeCustomers")}
            </div>
          </div>
          <div>
            <div className="text-xl font-semibold text-foreground">5.6k</div>
            <div className="text-xs text-muted-foreground">
              {t("repeatCustomers")}
            </div>
          </div>
          <div>
            <div className="text-xl font-semibold text-foreground">250k</div>
            <div className="text-xs text-muted-foreground">
              {t("shopVisitor")}
            </div>
          </div>
          <div>
            <div className="text-xl font-semibold text-foreground">5.5%</div>
            <div className="text-xs text-muted-foreground">
              {t("conversionRate")}
            </div>
          </div>
        </div>*/}

        {/* Chart Placeholder */}
        <div className="h-40 bg-gradient-to-b from-green-100 via-green-200 to-green-50 rounded-md relative">
          <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center text-green-700 font-semibold">
            Chart goes here
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerFilters;
